"use client"

import { ArrowLeft, LucideIcon } from "lucide-react"
import { Link, useNavigate } from "@tanstack/react-router"
import { Button } from "@city-sage/aurum-avis-labs-components"

interface CompactHeaderProps {
  backTo?: string | 'historyback'
  icon: LucideIcon
  title: string
  subtitle: string
}

export default function CompactHeader({ backTo, icon: Icon, title, subtitle }: CompactHeaderProps) {

  const handleBack = () => {
    if (backTo === 'historyback') {
      window.history.back()
    }
  }

  return (
    <div className="bg-white px-4 py-2 border-b border-gray-200">
      <div className="flex items-center justify-between">
        {backTo && (
          backTo === 'historyback' ? (
            <Button
              variant="ghost"
              size="sm"
              className="flex items-center gap-1.5 px-2 py-1 text-gray-600 hover:text-gray-900 -ml-2"
              onClick={handleBack}
            >
              <ArrowLeft className="h-3.5 w-3.5" />
              <span className="text-sm">Back</span>
            </Button>
          ) : (
            <Link to={backTo}>
              <Button
                variant="ghost"
                size="sm"
                className="flex items-center gap-1.5 px-2 py-1 text-gray-600 hover:text-gray-900 -ml-2"
              >
                <ArrowLeft className="h-3.5 w-3.5" />
                <span className="text-sm">Back</span>
              </Button>
            </Link>
          )
        )}

        <div className="flex items-center gap-2.5">
          <div className="flex items-center justify-center w-6 h-6 bg-primary rounded-full">
            <Icon className="h-3 w-3 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-gray-900 leading-tight">{title}</h1>
            <p className="text-xs text-gray-500 leading-tight">{subtitle}</p>
          </div>
        </div>

        {/* Spacer to balance the layout */}
        <div className="w-16"></div>
      </div>
    </div>
  )
} 